import React, { useEffect, useState } from "react";
import "./truchamp.scss";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useDispatch } from "react-redux";
import { TruChampAction } from "../../actions/truChampAction";
 
// Firebase imports
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import {
  getFirestore,
  doc,
  getDoc,
  updateDoc,
  increment,
} from "firebase/firestore";
 
function TruChamp() {
  const [linkStatus, setLinkStatus] = useState({
    isExpired: false,
    referCode: null,
    isLoading: true,
    errorMessage: "",
  });
  const [analytics, setAnalytics] = useState(null);
  const [firestore, setFirestore] = useState(null);
 
  const dispatch = useDispatch();
 
  useEffect(() => {
    // Parse query parameters
    const queryParams = new URLSearchParams(window.location.search);
    const couponCode = queryParams.get("coupon_code");
    const referCode = queryParams.get("referral_code");
    const uuid = queryParams.get("uuid");
    const redirectCode = queryParams.get("redirect_code");
 
    if (couponCode) {
      // Initialize Firebase for coupon code flow
      initializeFirebase();
      // Keep the default app functionality
      setLinkStatus({
        isExpired: false,
        referCode: null,
        isLoading: false,
        errorMessage: "",
      });
    } else if (referCode && uuid ) {
      // Handle referral code flow
      validateReferralCode(referCode, uuid, redirectCode);
    } else {
      // No valid parameters
      setLinkStatus({
        isExpired: true,
        referCode: null,
        isLoading: false,
        errorMessage: "",
      });
    }
  }, []);
 
  // Initialize Firebase
  const initializeFirebase = async () => {
    try {
      const firebaseConfig = {
        apiKey: process.env.REACT_APP_API_KEY,
        authDomain: process.env.REACT_APP_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_PROJECT_ID,
        storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_APP_ID,
        measurementId: process.env.REACT_APP_MEASUREMENT_ID,
      };
 
      const app = initializeApp(firebaseConfig);
      const analyticsInstance = getAnalytics(app);
      const firestoreInstance = getFirestore(app);
 
      setAnalytics(analyticsInstance);
      setFirestore(firestoreInstance);
 
      // Log app open event
      if (analyticsInstance) {
        logEvent(analyticsInstance, 'app_open', {
          source: 'coupon_code'
        });
      }
    } catch (error) {
      console.error("Firebase initialization error:", error);
      setLinkStatus((prev) => ({
        ...prev,
        isLoading: false,
        errorMessage: "Error initializing. Please try again later.",
      }));
    }
  };
 
  // Validate referral code
  const validateReferralCode = async (referCode, uuid, redirectCode) => {
    if (!referCode || !uuid) {
      setLinkStatus({
        isExpired: true,
        referCode: null,
        isLoading: false,
        errorMessage: "Missing referral code or UUID.",
      });
      return;
    }
 
    const payload = {
      referral_code: referCode,
      uuid: uuid,
    };
 
    try {
      const response = await dispatch(TruChampAction(payload));
      if (response?.status === 200) {
        if (response.data?.success === true) {
          // Check if expired based on API response
          const isExpired = response?.data?.expired === true;
 
          if (isExpired) {
            setLinkStatus({
              isExpired: true,
              referCode: referCode,
              isLoading: false,
              errorMessage: response.data?.errors,
            });
          } else {
            // Link is valid and not expired
            if (redirectCode) {
              // Directly redirect when redirect_code is present
              const redirectUrl = `https://truchamp.page.link/${redirectCode}`;
              console.log("Redirecting to:", redirectUrl);
              
              // Set a short timeout before redirecting
              setTimeout(() => {
                window.location.href = redirectUrl;
              }, 1000);
              
              // Update UI to show success but waiting for redirect
              setLinkStatus({
                isExpired: false,
                referCode: referCode,
                isLoading: false,
                errorMessage: "",
              });
            } else {
              // No redirect_code, but validation successful
              setLinkStatus({
                isExpired: false,
                referCode: referCode,
                isLoading: false,
                errorMessage: "",
              });
            }
          }
        } else {
          // API returned success: false
          setLinkStatus({
            isExpired: true,
            referCode: referCode,
            isLoading: false,
            errorMessage: response.data?.error?.message || "Invalid referral code.",
          });
        }
      } else {
        // API request failed
        setLinkStatus({
          isExpired: true,
          referCode: referCode,
          isLoading: false,
          errorMessage: response.data?.errors || "API request failed",
        });
      }
    } catch (error) {
      console.error("Error validating referral code:", error);
      setLinkStatus({
        isExpired: true,
        referCode: referCode,
        isLoading: false,
        errorMessage: "Error validating referral code.",
      });
    }
  };
 
  function RedirectApple() {
    if (linkStatus.isExpired) {
      alert(linkStatus.errorMessage);
      return;
    }
 
    // Open App Store
    window.open(
      "https://apps.apple.com/in/app/truchamp/id6447317410",
      "_blank"
    );
  }
 
  function RedirectGoogle() {
    if (linkStatus.isExpired) {
      alert(linkStatus.errorMessage);
      return;
    }
 
    // Open Play Store
    window.open(
      "https://play.google.com/store/apps/details?id=com.tvs.tvs_pgm_prod",
      "_blank"
    );
  }
 
  // Show loading state
  if (linkStatus.isLoading) {
    return (
      <div className="true-champ-container">
        <div className="true-champ">
          <img
            className="true-champ-logo"
            src={Image_Url.TruChamp}
            alt="TruChamp Logo"
          />
        </div>
        <div className="true-champ-button">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }
 
  return (
    <div className="true-champ-container">
      <div className="true-champ">
        <img
          className="true-champ-logo"
          src={Image_Url.TruChamp}
          alt="TruChamp Logo"
        />
      </div>
 
      {linkStatus.isExpired ? (
        <div className="true-champ-button">
          <h2>{linkStatus.errorMessage}</h2>
          <div className="download-buttons disabled">
            <img
              src={Image_Url.DOWNLOAD_APPPLE}
              alt="Download on the App Store"
              style={{ cursor: "not-allowed", opacity: 0.5 }}
            />
            <img
              src={Image_Url.DOWNLOAD_GOOGLE}
              alt="Get it on Google Play"
              style={{ cursor: "not-allowed", opacity: 0.5 }}
            />
          </div>
        </div>
      ) : (
        <div className="true-champ-button">
          <div className="truchamp-text">Download TruChamp App</div>
          <div className="download-buttons">
            <img
              src={Image_Url.DOWNLOAD_APPPLE}
              onClick={RedirectApple}
              alt="Download on the App Store"
              style={{ cursor: "pointer" }}
            />
            <img
              src={Image_Url.DOWNLOAD_GOOGLE}
              onClick={RedirectGoogle}
              alt="Get it on Google Play"
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
 
export default TruChamp;